

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { ScreenPermissionsSetup } from "../../../components/RoleManagement/ScreenPermissionsSetup";


export const ScreenPermissionsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Screen Permissions"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Screen Permissions", navigateTo: "/role-management/screen-permissions" }
      ]}
      mainContents={<ScreenPermissionsSetup />}
    />
  );
};
